import React from 'react'
import { MdPhone } from 'react-icons/md'
import { Container } from '@/components/Container'
import { IconButton } from '@/components/IconButton'
import { PaddedBlock } from '@/components/PaddedBlock'
import { Touchable } from '@/components/Touchable'
import { BRAND_ABBR_TITLE } from '@/data/business'
import { PHONE_PRIMARY, PHONE_PRIMARY_DISPLAY } from '@/data/contact'
import './index.css'

type HeaderProps = {
  className?: string
  insertBefore?: React.ReactNode
  style?: React.CSSProperties
}

export const Header = ({ className = '', style, insertBefore }: HeaderProps) => (
  <header className={`Header--root ${className}`} style={style}>
    <Container>
      <PaddedBlock>
        <div className="Header--content">
          {insertBefore}
          <Touchable to="/">
            <h1 className="Header--brand">
              <abbr title={BRAND_ABBR_TITLE}>M/Y</abbr>
              <span>Christina</span>
            </h1>
          </Touchable>
        </div>
      </PaddedBlock>
    </Container>
  </header>
)
